/**
 * useHasCreditsEnforcement will control whether or not
 * show credits enforcement stuff around the platform, so that we have a single source of truth
 *
 * @returns boolean
 */

import { creditsEnforcementEnabled, userHasClaims } from "../utils/auth";

export const useHasCreditsEnforcement = () => {
  return userHasClaims([creditsEnforcementEnabled]);
};
